import { useEffect, useState } from "react";
import { auth } from "./configuration/firebase";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { get_current_user } from "./api/endpoints/users";
import "./App.css";
import LoadingScreen from "./components/common/loading-screen/LoadingScreen";
import {
	ConfirmEmail,
	SignIn,
	ForgotPassword,
	ResetPassword,
	MobileSignIn,
} from "./components/pages/auth";
import Main from "./components/root/Main";
import { useAuth } from "./contexts/authContext";
import { BookProvider } from "./contexts/bookContext";
import { CartProvider } from "./contexts/cartContext";
import "moment/locale/es";
import useIsMobile from "./hooks/useIsMobile";
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./configuration/applicationInsightsConfig";
import axiosInstance from "./api/axiosInstance";
import { FilterProvider } from "./contexts/filterContext";
import { TermsAndPolicy } from "./components/pages/admin";

function App() {
	const { user, userdata, ready } = useAuth();
	const [dbUser, dbSetUser] = useState(null);
	const isMobile = useIsMobile();

	axiosInstance.interceptors.request.use(
		async (config) => {
			const token = await auth?.currentUser?.getIdToken();

			if (!token) {
				return config;
			}

			config.headers = {
				...config.headers,
				authorization: `Bearer ${token}`,
			};

			return config;
		},
		(error) => {
			console.log("axios interceptor error");
			return Promise.reject(error);
		}
	);

	const search = window.location.search;
	const params = new URLSearchParams(search);
	const mode = params.get("mode");
	const oobCode = params.get("oobCode");

	useEffect(() => {
		const fetch_user = async () => {
			const res = await get_current_user();
			dbSetUser(res);
		};

		if (ready) {
			fetch_user();
		}
	}, [ready]);

	return (
		<BrowserRouter>
			<Routes>
				<Route path="/forgot-password" element={<ForgotPassword />} />

				<Route exact path="/termsAndPolicy" element={<TermsAndPolicy />} />

				<Route
					path="/*"
					element={
						isMobile ? (
							<MobileSignIn />
						) : mode === "resetPassword" && oobCode ? (
							<ResetPassword />
						) : mode === "verifyEmail" && oobCode ? (
							<ConfirmEmail />
						) : !user ? (
							<SignIn />
						) : !ready ? (
							<LoadingScreen message="Cargando informacion de usuario..." />
						) : !userdata.validated ? (
							<SignIn newUserData={userdata} />
						) : dbUser?.deleted ? (
							<SignIn deletedUser={dbUser.deleted} />
						) : !userdata?.isOneMarket && !userdata?.isSeller ? (
							<SignIn
								blockedUser={!userdata?.isOneMarket && !userdata?.isSeller}
							/>
						) : (
							<AppInsightsContext.Provider value={reactPlugin}>
								<FilterProvider>
									<CartProvider>
										<BookProvider>
											<Main userdata={userdata} clientUser={dbUser} />
										</BookProvider>
									</CartProvider>
								</FilterProvider>
							</AppInsightsContext.Provider>
						)
					}
				/>
			</Routes>
		</BrowserRouter>
	);
}

export default App;
